import { connect } from 'react-redux';

const mapStateToProps = state => ({
  markersArray: state.mainreducer.markers,
  defaultMapLatitude: state.mainreducer.defaultMapLatitude,
  defaultMapLongitude: state.mainreducer.defaultMapLongitude,
});


export default MainMapWrapper => connect(mapStateToProps, null)(MainMapWrapper);
